import $      from 'jquery';
import Reflux from 'reflux';
import Errors from '../error-messages/actions';

const Helpers = {
  getPostData(state) {
    return {
      formId: state.formId,
      questionResponses: this.getResponseList(state.questions),
      questionnaireId: state.qid,
      siteId: 2001
    };
  },
  getResponseList(questions) {
    let responseList = [];
    questions.forEach((question) => {
      let choices = question.choices;
      if(question.displayType==4 || question.displayType==5) {
        let responseText = question.responseText ? question.responseText : "";
        let response = {
          questionId: question.questionId,
          responseText: responseText
        };
        responseList.push(response);
        return;
      }
      let selectedChoices = choices.filter((choice) => {
        return choice.selected;
      });
      if (selectedChoices.length > 0) {
        selectedChoices.forEach((choice) => {
          let response = {
            choiceId: choice.choiceId,
            questionId: question.questionId
          };
          responseList.push(response);
        });
      }
    });
    return responseList;
  }
};

const ApiEvents = {
  "get": {
    children: ['completed', 'failed']
  },
  "post": {
    children: ['completed', 'failed']
  }
};

class ApiActionsFactory {
  constructor() {
    this.actions = {};
  }
  get(key) {
    if(!this.actions[key]) {
      this.actions[key] = Reflux.createActions(ApiEvents);
      this.initListeners(this.actions[key]);
    }
    return this.actions[key];
  }
  clearCache() {
    Object.keys(this.actions).forEach((key)=> {
      delete this.actions[key];
    });
  }
  initListeners(ApiActions) {
    ApiActions.get.listen(function(qid, formId) {
      Errors.update([]);
      let app = window.medscape;
      let path = `${app.config.apiHost.replace("www","api")}/servicegateway/v2/auth/qnaservice/questionnaire`;
      let qnaUrl = `${path}/${qid}/form/${formId}`;
      let getData = {
          aggregated: true
      };
      $.ajax({
        type: 'get',
        url: qnaUrl,
        data: getData,
        dataType: 'json',
        cached: false,
        xhrFields: {
          withCredentials: true
        },
        statusCode: {
          '404': () => {
            console.log('404');
          },
          '403': (response) => {
            console.error("403 Response");
            //this.completed(response);
            this.failed(response);
          }
        }
      }).then((response) => {
          response.qid = qid;
          this.completed(response);
      }, this.failed);
    });
    ApiActions.post.listen(function(postState) {
      //let postUrl = window.medscape.config.qna.api.post;
      Errors.update([]);
      let app = window.medscape,
          api = '';
      //let api = postState.formTypeId==1 ? 'courseservice/saveUserResponse' : 'activityservice/save/useractivity';
      //http://api.medscape.com/servicegateway/v2/auth/courseservice/saveUserResponse
      if(app.user.isLoggedIn){
          api = 'qnaservice/save/userresponse';
      } else {
          api = 'qnaservice/save/anonymousresponse';
      }
      let postUrl = `${app.config.apiHost.replace('www','api')}/servicegateway/v2/auth/${api}?aggregated=true`;
      let postData = Helpers.getPostData(postState);
      if (postData.questionResponses.length == 0) {
        this.failed({
          "errors": [{
            "status": "400",
            "source": postData,
            "title": "Select a choice",
            "detail": "The questionnaire submitted without any responses."
          }]
        });
        return false;
      }
      let errorStatus = () => {
        console.error("403 Response ", window.medscape.config.env);
        if (window.medscape.config.env == 'localhost') {
          console.log("In Localhost", this);
          this.completed({
            "responseMsg": {
              "code": "1",
              "message": "SUCCESS",
              "nextViewPage": "",
              "data": {
                "incorrectlyAnsweredQuestionIds": []
              }
            }
          });
        }
      };
      $.ajax({
        type: 'POST',
        contentType: "application/json",
        dataType: "json",
        processData: false,
        url: postUrl,
        data: JSON.stringify(postData),
        xhrFields: {
          withCredentials: true
        },
        statusCode: {
          '401': errorStatus,
          '404': () => {
            console.error('404');
          },
          '403': errorStatus
        }
      }).then(this.completed, this.failed);
    });
  } // initListeners
}
export default new ApiActionsFactory();



// WEBPACK FOOTER //
// ./medscape_modules/qna/api/actions-factory.js